import script from "./WorkspaceLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkspaceLayout.vue?vue&type=script&setup=true&lang=js"

import "./WorkspaceLayout.vue?vue&type=style&index=0&id=6ebc139a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ebc139a"]])

export default __exports__